










































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import Swiper from '@/components/Swiper';
import { capitalize } from '@/utils';

@Component({
  name: 'CatalogHorizontalTile',
  components: {
    Swiper,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    design: {
      type: String,
      default: '',
    },
    floor: {
      type: Number,
      default: 0,
    },
    rooms: {
      type: Number,
      default: 0,
    },
    area: {
      type: Number,
      default: 0,
    },
    building: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    price: {
      type: [Number, String],
      default: 0,
    },
    texts: {
      type: Object,
      default: {},
    },
    reservation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperOption: {
        mobile: true,
        linkTo: this.$router.resolve({
          name: 'reservation',
          params: {
            id: this.id,
            design: capitalize((this as any).design.toLowerCase()),
            rooms: (this as any).rooms,
          },
        }).href,
        fullWidth: false,
        width: 350,
        height: 220,
        loop: true,
        navigation: {
          class: 'nav-icon',
        },
        pagination: false,
      },
    };
  },
  computed: {
    ...mapGetters('catalog', [
      'catalogItem',
    ]),
    designCapitalize() {
      return capitalize((this as any).design.toLowerCase());
    },
  },
})
export default class CatalogHorizontalTile extends Vue {
}
